<template>
    <form class="edit-tile" v-bind:action="apiUrl + '/tiles' + (id ? ('/' + id) : '')" v-on:submit.prevent="handleSubmit">
        <div class="edit-tile__cols">
            <div class="edit-tile__col">
                <div class="form__group" v-bind:class="{ 'has-error' : errors.url }">
                    <label class="form__label" for="url">{{ __('Website URL') }}</label>
                        <input class="form__control is-large" id="url" type="text" autocomplete="off"
                           v-bind:placeholder="__('Enter URL')"
                           v-model="url"
                           v-on:blur="computeUrlObj"
                    />
                    <span class="form__focus"></span>
                </div>
                <small class="form__error" v-if="errors.url">{{ errors.url[0] }}</small>

                <div class="form__group" v-bind:class="{ 'has-error' : errors.name }">
                    <label class="form__label" for="name">{{ __('Tile name') }}</label>
                    <input class="form__control is-large" id="name" type="text" autocomplete="off"
                           v-bind:placeholder="__('Enter tile name')"
                           v-model="name"
                    />
                    <span class="form__focus"></span>
                </div>
                <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

                <div class="form__group" v-if="user.is_admin && categoryId != 'custom' && ((this.id && startdeskId == null) || !this.id)">
                    <label class="form__label">{{ __('Category') }}</label>
                    <select class="form__control" v-bind:id="'category[' + index + ']'"
                            v-for="(categ, index) in selectedCategories"
                            v-model="selectedCategories[index]"
                            v-on:change="handleCategoryChange(index)"
                    >
                        <option v-for="cat in categories[index]" v-bind:value="cat.id">{{ cat.name }} ({{ cat.children.length }})</option>
                    </select>
                    <span class="form__focus"></span>
                </div>

                <div class="form__group">
                    <toggle v-bind:click="toggleIsAffiliate"
                            v-bind:label="__('Is affiliate?')"
                            v-if="user.is_admin"
                            v-model="isAffiliate"
                    />
                </div>
            </div>
            <div class="edit-tile__col">
                <div class="form__group">
                    <label class="form__label">{{ __('Tile image') }}</label>
                    <label class="form__radio">
                        <input name="imageType" type="radio" v-model="imageType" v-on:click="handleImageRadioClick" value="text"/>{{ __('Text') }}
                    </label>
                    <label class="form__radio has-margin-l10">
                        <input name="imageType" type="radio" v-model="imageType" v-on:click="handleImageRadioClick" value="logo"/>{{ __('Logo') }}
                    </label>
                    <label class="form__radio has-margin-l10">
                        <input name="imageType" type="radio" v-model="imageType" v-on:click="handleImageRadioClick" value="auto"/>{{ __('Screenshot') }}
                    </label>
                    <label class="form__radio">
                        <input name="imageType" type="radio" v-model="imageType" v-on:click="handleImageRadioClick" value="custom"/>{{ __('Custom image') }}
                    </label>
                </div>
                <div class="tile" v-bind:style="tileBackgroundProperty + tileSizeProperties"  v-bind:title="name">
                    <div class="tile__preview"
                         v-bind:class="{ 'is-loaded' : imageObj.isLoaded }"
                         v-bind:style="imageStyleProperty"
                         v-on:mousedown="handleImageDragStart"
                         v-on:mousemove="handleImageDrag"
                         v-on:mouseup="handleImageDragEnd">
                        <img class="tile__image"
                             v-bind:src="imageObj.src"
                             v-if="imageObj.src"
                        />
                    </div>
                    <span class="tile__icon" style="height: 126px;" v-if="!imageObj.src">
                        <svg viewBox="0 0 100 100" v-if="urlObj && imageType == 'text'">
                            <text x="0" y="15" textLength="75"
                                  v-bind:style="tileFillProperty"
                                  v-if="urlObj.subdomain">{{ urlObj.subdomain }}.
                            </text>
                            <text x="0" y="36" textLength="100"
                                  v-bind:font-size="7 / urlObj.domain.length * 24"
                                  v-bind:style="tileFillProperty"
                                  v-if="urlObj.domain">{{ urlObj.domain }}
                            </text>
                            <text x="50" y="51" textLength="40"
                                  v-bind:style="tileFillProperty"
                                  v-if="urlObj.tld">.{{ urlObj.tld }}
                            </text>
                        </svg>
                    </span>
                    <span class="tile__name vertically-centered" v-bind:style="textColorProperty"><div>{{ name != '' ? name : __('Tile') }}</div></span>
                </div>

                <div v-if="imageObj.src">
                    <input class="edit-tile__scale-image-control" type="range" step="0.01"
                           v-bind:min="imageObj.scaleMin"
                           v-bind:max="imageObj.scaleMax"
                           v-if="showScaleImageControl"
                           v-model.number="imageObj.scale"
                           v-on:input="handleImageScale"
                    />
                    <a class="btn edit-tile__center-image-btn" v-if="showScaleImageControl" v-on:click="centerImage">{{ __('Center image') }}</a>

                    <a class="btn is-danger edit-tile__remove-image-btn" v-on:click="removeImage">{{ __('Remove image') }}</a>
                </div>
                <div v-if="imageType == 'custom'">
                    <a class="btn is-primary" v-on:click="showImageUploadDialog">{{ __('Upload tile image') }}</a>
                    <input class="edit-tile__image-control" type="file" accept="image/*" v-on:change="handleImageUpload" />
                </div>
            </div>
            <div class="edit-tile__col">
                <color-picker v-bind:label="__('Tile text')" v-model="colors.tileColor" ref="tileColorRef" />
                <color-picker v-bind:label="__('Tile background')" v-model="colors.tileBackground" ref="tileBackgroundRef" />
                <color-picker v-bind:label="__('Name text')" v-model="colors.textColor" ref="textColorRef" />
                <color-picker v-bind:label="__('Name background')" v-model="colors.textBackground" ref="textBackgroundRef" />
            </div>
        </div>

        <button class="btn is-primary edit-tile__save-btn" type="submit">{{ __('Save') }}</button>
    
        <div class="logo-selector is-active" v-if="logoSelectorIsActive">
            <div class="logo-selector content">
                <p>
                    Click on a logo to select!
                    <a class="logo-selector__close" v-on:click="closeLogoSelector">&times;</a>
                </p>
                <div v-for="logo in logoList">
                    <img v-bind:src="logo.image" v-on:click="selectLogo(logo)" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import colorPicker from '../elements//ColorPicker.vue';
    import toggle from '../elements//Toggle';

    export default {
        components: {
            colorPicker,
            toggle
        },
        computed: {
            imageStyleProperty: function () {
                let prop = '';

                let height = this.imageObj.height;
                let width = this.imageObj.width;
                let scale = this.imageObj.scale;

                if (this.imageObj.height != 0 && this.imageObj.width != 0) {
                    if (this.imageObj.initialHeight && this.imageObj.initialWidth) {
                        prop += 'height: ' + (height * scale) + 'px; ';
                        prop += 'width: ' + (width * scale) + 'px; ';
                    }

                    prop += 'transform: translate(' + this.imageObj.currentX + 'px, ' + this.imageObj.currentY + 'px);';
                } else {
                    prop = 'transform: translate(0px, 0px);';
                }

                return prop.trim();
            },
            textColorProperty: function () {
                return 'background-color: ' + (this.colors.textBackground ? this.colors.textBackground.hex : "#002631") + '; color: ' + this.colors.textColor.hex + ';';
            },
            tileBackgroundProperty: function () {
                return 'background-color: ' + this.colors.tileBackground.hex + ';';
            },
            tileFillProperty: function () {
                return 'fill: ' + this.colors.tileColor.hex + ';';
            },
            tileSizeProperties: function () {
                return 'height: ' + (this.tileImgHeight + 40) + 'px;' + 'width: ' + this.tileImgWidth + 'px;';
            }
        },
        data: function () {
            return {
                categories: [],
                categoryId: this.category,
                categoryHierarchy: [],
                colors: {
                    textBackground: {
                        hex: '#002631',
                        hsl: { h: 193, s: 100, l: 9.6, a: 1 },
                        hsv: { h: 193, s: 100, v: 19.2, a: 1 },
                        rgba: { r: 0, g: 38, b: 49, a: 1 },
                        a: 1
                    },
                    textColor: {
                        hex: '#ffffff',
                        hsl: { h: 0, s: 0, l: 1, a: 1 },
                        hsv: { h: 0, s: 0, v: 1, a: 1 },
                        rgba: { r: 255, g: 255, b: 255, a: 1 },
                        a: 1
                    },
                    tileBackground: {
                        hex: '#ffffff',
                        hsl: { h: 0, s: 0, l: 1, a: 1 },
                        hsv: { h: 0, s: 0, v: 1, a: 1 },
                        rgba: { r: 255, g: 255, b: 255, a: 1 },
                        a: 1
                    },
                    tileColor: {
                        hex: '#5e8dff',
                        hsl: { h: 222, s: 0.04, l:.98, a: 1 },
                        hsv: { h: 240, s: 0, v: .98, a: 1 },
                        rgba: { r: 240, g: 243, b: 250, a: 1 },
                        a: 1
                    }
                },
                errors: {},
                imageObj: {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialHeight: 0,
                    initialWidth: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    scaleMin: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                },
                isAffiliate: false,
                imageType: 'text',
                name: '',
                selectedCategories: [],
                showScaleImageControl: false,
                startdeskId: this.startdesk,
                tileImgHeight: 126,
                tileImgWidth: 180,
                url: '',
                urlObj: {},
                logoSelectorIsActive: false,
                logoList: [],
            }
        },
        methods: {
            centerImage: function () {
                this.imageObj.currentX = Math.floor((180 - this.imageObj.width * this.imageObj.scale) / 2);
                this.imageObj.currentY = Math.floor((126 - this.imageObj.height * this.imageObj.scale) / 2);

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
            },
            computeUrlObj: function() {
                try {
                    let url = this.url;

                    // add protocol if not present
                    if (!url.match(/^[a-zA-Z]+:\/\//)) {
                        url = 'https://' + url;
                    }

                    const urlObj = new URL(url);
                    const urlArr = urlObj.hostname.split('.', -2).reverse();

                    this.urlObj = {
                        domain: urlArr[1],
                        subdomain: (urlArr[2] && urlArr[2] != 'www') ? urlArr[2] : null,
                        tld: urlArr[0]
                    };

                    if (this.name === null || this.name === ''
                        || this.description === null || this.description === '') {
                        this.$http.get(this.apiUrl + '/get_meta?url=' + url).then(function (response) {
                            if (!response.data)
                                return;
                            if (response.data.name !== '' && (this.name === null || this.name === ''))
                                this.name = response.data.name;
                            if (response.data.description !== '' && (this.description === null || this.description === ''))
                                this.description = response.data.description;
                            //if (response.data.keywords !== '' && (this.tags === null || this.tags === ''))
                            //    this.tags = response.data.keywords;
                        }, function (response) {
                            //console.log(response);
                        });
                    }
                } catch (e) {
                    this.urlObj = {};
                }
            },
            closeLogoSelector: function () {
                this.logoSelectorIsActive = false;
                this.logoList = [];
            },
            selectLogo: function (logo) {
                const img = new Image();
                img.src = logo.image;
                this.imageObj.offsetY = -27;
                this.imageObj.currentY = -27;
                this.imageObj.src = img.src;

                img.onload = function () {
                    const imgEl = document.querySelector('.tile__image');

                    this.imageObj.initialHeight = imgEl.offsetHeight;
                    this.imageObj.initialWidth = imgEl.offsetWidth;

                    this.imageObj.isLoaded = true;

                    this.imageObj.height = Math.floor(this.imageObj.initialHeight * this.imageObj.scale);
                    this.imageObj.width = Math.floor(this.imageObj.initialWidth * this.imageObj.scale);

                    let scale = 1;
                    let scaleW = 1;
                    let scaleH = 1;
                    if (this.tileImgWidth < this.imageObj.width) {
                        scaleW = this.tileImgWidth / this.imageObj.width;
                    }
                    if (this.tileImgHeight < this.imageObj.height) {
                        scaleH = this.tileImgHeight / this.imageObj.height;
                    }
                    if (scaleW > scaleH)
                        scale = scaleH;
                    else
                        scale = scaleW;
                    this.imageObj.height = this.imageObj.height * scale;
                    this.imageObj.width = this.imageObj.width * scale;

                    this.showScaleImageControl = true;

                    if (imgEl.offsetWidth <= img.width) {
                        this.imageObj.scaleMin = 0.1;
                        this.imageObj.scaleMax = Math.floor(img.width / imgEl.offsetWidth);
                    } else {
                        this.imageObj.scaleMin = Math.floor(imgEl.offsetWidth / img.width);
                        this.imageObj.scaleMax = 0.1;
                    }
                    if (this.imageObj.scaleMin > this.imageObj.scaleMax) {
                        var tmp = this.imageObj.scaleMax;
                        this.imageObj.scaleMax = this.imageObj.scaleMin;
                        this.imageObj.scaleMin = tmp;
                    }
                    
                    this.centerImage();
                    this.imageType = 'logo';

                    this.closeLogoSelector();
                }.bind(this);
            },
            fetchLogo: function() {
                if (this.url == '') {
                    return;
                }

                eventBus.$emit('show-loader');

                let url = this.url;

                // add protocol if not present
                if (!url.match(/^[a-zA-Z]+:\/\//)) {
                    url = 'https://' + url;
                }
                var all = 'all&';
                this.$http.get(this.apiUrl + '/icons?' + all + 'url=' + url).then(function (response) {
                    if (!response.body || !response.body.original || (!response.body.original.image && !response.body.original.images)) {
                        eventBus.$emit('hide-loader');
                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('Failed to get website logo!')
                        );
                        return;
                    }

                    if (all == '&all') {
                        if (response.body.original.images.length == 0) {
                            eventBus.$emit(
                                    'show-alert',
                                    'error',
                                    this.__('Website logo not found!')
                            );
                        } else if (response.body.original.images.length == 1) {
                            this.selectLogo(response.body.original.images[0]);
                        } else {
                            this.logoList = response.body.original.images;
                            this.logoSelectorIsActive = true;
                        }
                    } else {
                        this.selectLogo(response.body.original);
                    }

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit('hide-loader');
                });



            },
            generateScreenshot: function () {
                if (this.url == '') {
                    return;
                }

                eventBus.$emit('show-loader');

                let url = this.url;

                // add protocol if not present
                if (!url.match(/^[a-zA-Z]+:\/\//)) {
                    url = 'https://' + url;
                }

                //this.$http.get('https://www.googleapis.com/pagespeedonline/v5/runPagespeed?screenshot=true&url=' + url).then(function (response) {
                //    let screenshot = response.data.lighthouseResult.audits['final-screenshot'].details;
                this.$http.get('/api/v1/scr?url=' + url).then(function (response) {
                    let screenshot = response.data.details;
                    //console.log(screenshot);

                    // Set the image's source.
                    const img = new Image();
                    img.src = screenshot.data;
                    this.imageObj.src = img.src;

                    img.onload = function () {
                        const imgEl = document.querySelector('.tile__image');

                        this.imageObj.initialHeight = imgEl.offsetHeight;
                        this.imageObj.initialWidth = imgEl.offsetWidth;

                        this.imageObj.isLoaded = true;

                        this.imageObj.height = Math.floor(this.imageObj.initialHeight * this.imageObj.scale);
                        this.imageObj.width = Math.floor(this.imageObj.initialWidth * this.imageObj.scale);

                        let scale = 1;
                        if (this.tileImgWidth > this.imageObj.width) {
                            scale = this.tileImgWidth / this.imageObj.width;
                        }
                        if (this.tileImgHeight > this.imageObj.height) {
                            scale = this.tileImgHeight / this.imageObj.height;
                        }
                        this.imageObj.height = this.imageObj.height * scale;
                        this.imageObj.width = this.imageObj.width * scale;

                        this.showScaleImageControl = true;

                        if (this.imageObj.width < img.width) {
                            this.imageObj.scaleMin = 0.1;
                            this.imageObj.scaleMax = Math.floor(img.width / this.imageObj.width);
                        } else {
                            this.imageObj.scaleMin = Math.floor(this.imageObj.width / img.width);
                            this.imageObj.scaleMax = 0.1;
                        }

                        this.centerImage();
                    }.bind(this);

                    eventBus.$emit('hide-loader');
                }.bind(this), function () {
                    eventBus.$emit('hide-loader');
                });
            },
            getCategories: function (cat, index) {
                var parent = cat;
                if (typeof parent == 'undefined') {
                    parent = '';
                }

                if (typeof index == 'undefined') {
                    index = 0;
                }

                this.$delete(this.categories, index);

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/tiles/categories', {
                    params : {
                        page: 1,
                        filters: {
                            parent: parent
                        },
                        perPage: 0,
                        sortBy: 'name',
                        sortOrder: 'asc'
                    }
                }).then(function (response) {
                    this.$set(this.categories, index, response.body.original.data);
                    if (this.categories[index].length > 0 && typeof this.selectedCategories[index] == 'undefined') {
                        this.$set(this.selectedCategories, index, '');
                    }

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            getTile: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/tiles/' + this.id).then(function (response) {
                    const tile = response.body;

                    this.categoryId = tile.category_id;
                    this.name = tile.name;
                    this.startdeskId = tile.startdesk_id;
                    this.url = tile.url;
                    this.isAffiliate = !!tile.is_affiliate;
                    this.categoryHierarchy = tile.category_hierarchy;
                    this.imageType = tile.image_type;

                    if (this.categoryHierarchy.length > 0) {
                        this.categoryHierarchy.forEach(function(cat, index) {
                            this.getCategories(cat.parent_id, index);
                            this.selectedCategories[index] = cat.id;

                            this.getCategories(cat, index + 1);
                        }.bind(this));
                    }

                    this.computeUrlObj();

                    if (tile.image) {
                        this.imageObj.src = '/media/tiles/' + tile.image;
                    }

                    if (tile.text_background) {
                        this.colors.textBackground = { hex: tile.text_background };
                        this.$refs.textBackgroundRef.color = this.colors.textBackground;
                    }
                    if (tile.text_color) {
                        this.colors.textColor = { hex: tile.text_color };
                        this.$refs.textColorRef.color = this.colors.textColor;
                    }
                    if (tile.tile_background) {
                        this.colors.tileBackground = { hex: tile.tile_background };
                        this.$refs.tileBackgroundRef.color = this.colors.tileBackground;
                    }
                    if (tile.tile_color) {
                        this.colors.tileColor = { hex: tile.tile_color };
                        this.$refs.tileColorRef.color = this.colors.tileColor;
                    }

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleCategoryChange: function (index) {
                for (let i = index + 1; i < this.categories.length; i++) {
                    this.$delete(this.categories, i);
                    this.$delete(this.selectedCategories, i);
                }
                this.getCategories(this.selectedCategories[index], index + 1);
                this.categoryId = this.selectedCategories[index];
            },
            handleImageDrag: function (e) {
                if (this.imageObj.isMoving) {
                    e.preventDefault();

                    if (e.type === "touchmove") {
                        this.imageObj.currentX = e.touches[0].clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.touches[0].clientY - this.imageObj.initialY;
                    } else {
                        this.imageObj.currentX = e.clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.clientY - this.imageObj.initialY;
                    }

                    if (this.imageObj.width * this.imageObj.scale >= this.tileImgWidth) {
                        if (this.imageObj.currentX < 0 && this.imageObj.currentX < -1 * this.imageObj.width * this.imageObj.scale + this.tileImgWidth) {
                            this.imageObj.currentX = -1 * this.imageObj.width * this.imageObj.scale + this.tileImgWidth;
                        } else if (this.imageObj.currentX > 0) {
                            this.imageObj.currentX = 0;
                        }
                    } else {
                        if (this.imageObj.currentX > 0 && this.imageObj.currentX > this.tileImgWidth - this.imageObj.width * this.imageObj.scale) {
                            this.imageObj.currentX = this.tileImgWidth - this.imageObj.width * this.imageObj.scale;
                        } else if (this.imageObj.currentX < 0) {
                            this.imageObj.currentX = 0;
                        }

                    }

                    if (this.imageObj.height * this.imageObj.scale >= this.tileImgHeight) {
                        if (this.imageObj.currentY < 0 && this.imageObj.currentY < -1 * this.imageObj.height * this.imageObj.scale + this.tileImgHeight) {
                            this.imageObj.currentY = -1 * this.imageObj.height * this.imageObj.scale + this.tileImgHeight;
                        } else if (this.imageObj.currentY > 0) {
                            this.imageObj.currentY = 0;
                        }
                    } else {
                        if (this.imageObj.currentY > 0 && this.imageObj.currentY > this.tileImgHeight - this.imageObj.height * this.imageObj.scale) {
                            this.imageObj.currentY = this.tileImgHeight - this.imageObj.height * this.imageObj.scale;
                        } else if (this.imageObj.currentY < 0) {
                            this.imageObj.currentY = 0;
                        }

                    }

                    this.imageObj.offsetX = this.imageObj.currentX;
                    this.imageObj.offsetY = this.imageObj.currentY;
                }
            },
            handleImageDragEnd: function (e) {
                e.preventDefault();

                this.imageObj.initialX = this.imageObj.currentX;
                this.imageObj.initialY = this.imageObj.currentY;

                this.imageObj.isMoving = false;
            },
            handleImageDragStart: function (e) {
                e.preventDefault();

                if (e.type === "touchstart") {
                    this.imageObj.initialX = e.touches[0].clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.touches[0].clientY - this.imageObj.offsetY;
                } else {
                    this.imageObj.initialX = e.clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.clientY - this.imageObj.offsetY;
                }

                if (e.target === document.querySelector('.tile__preview')) {
                    this.imageObj.isMoving = true;
                }
            },
            handleImageRadioClick: function (e) {
                this.imageType = e.target.value;

                if (this.imageType == 'auto') {
                    this.generateScreenshot();
                } else if (this.imageType == 'logo') {
                    this.fetchLogo();
                }

                this.removeImage();
            },
            handleImageScale: function () {
                this.imageObj.currentX = 0;
                this.imageObj.currentY = 0;

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
                
                this.centerImage();
            },
            handleImageUpload: function () {
                const file = document.querySelector('.edit-tile__image-control').files[0];
                const img = new Image();
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = function () {
                    img.src = reader.result;
                    this.imageObj.src = img.src;
                    this.imageObj.scale = 1;
                }.bind(this);

                img.onload = function () {
                    const imgEl = document.querySelector('.tile__image');

                    this.imageObj.initialHeight = imgEl.offsetHeight;
                    this.imageObj.initialWidth = imgEl.offsetWidth;

                    this.imageObj.isLoaded = true;

                    this.imageObj.height = Math.floor(this.imageObj.initialHeight * this.imageObj.scale);
                    this.imageObj.width = Math.floor(this.imageObj.initialWidth * this.imageObj.scale);

                    let scale = 1;
                    if (this.tileImgWidth > this.imageObj.width) {
                        scale = this.tileImgWidth / this.imageObj.width;
                    }
                    if (this.tileImgHeight > this.imageObj.height) {
                        scale = this.tileImgHeight / this.imageObj.height;
                    }
                    this.imageObj.height = this.imageObj.height * scale;
                    this.imageObj.width = this.imageObj.width * scale;

                    this.showScaleImageControl = true;

                    if (this.imageObj.width < img.width) {
                        this.imageObj.scaleMin = 0.1;
                        /*if (this.tileImgWidth < imgEl.offsetWidth){
                            this.imageObj.scaleMin = this.tileImgWidth / imgEl.offsetWidth;
                        } else if (this.tileImgHeight < imgEl.offsetHeight) {
                            this.imageObj.scaleMin = this.tileImgHeight / imgEl.offsetHeight;
                        }*/
                        this.imageObj.scaleMax = Math.floor(img.width / this.imageObj.width);
                    } else {
                        this.imageObj.scaleMax = Math.floor(this.imageObj.width / img.width);
                        this.imageObj.scaleMin = 0.1;
                    }
                    this.centerImage();
                    
                    if (document.querySelector('.edit-tile__image-control'))
                        document.querySelector('.edit-tile__image-control').value = null;

                }.bind(this);
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');
                const method = this.id ? 'patch' : 'post';

                eventBus.$emit('show-loader');

                this.$http[method](action, {
                    category_id: this.categoryId != 'custom' && this.categoryId != 'admin' ? this.categoryId : null,
                    colors: this.colors,
                    image: this.imageObj,
                    is_affiliate: this.isAffiliate ? 1 : 0,
                    name: this.name,
                    startdesk_id: this.category != 'admin' ? this.startdeskId : null,
                    url: this.url,
                    image_type: this.imageType
                }).then(function (response) {
                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully saved.'));

                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: this.activeStartdesk.slug, u: this.activeStartdesk.is_user_startdesk }
                    });

                    if (response.body.startdesk_id && response.body.startdesk_id != '') {
                        this.$http.post(this.apiUrl + '/startdesks/' + response.body.startdesk_id + '/screenshot');
                    }

                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                });
            },
            init: function () {
                if (this.id) {
                    this.getTile();
                }

                if (this.user.is_admin) {
                    this.getCategories();
                }
            },
            removeImage: function () {
                this.imageObj = {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    scaleMin: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                };
                if (document.querySelector('.edit-tile__image-control'))
                    document.querySelector('.edit-tile__image-control').value = null;
            },
            showImageUploadDialog: function () {
                document.querySelector('.edit-tile__image-control').click();
            },
            toggleIsAffiliate: function () {
                this.isAffiliate = this.isAffiliate ? 0 : 1;
            }

        },
        mounted: function () {
            this.init();
        },
        props: {
            category: {
                default: null,
                type: String
            },
            id: {
                default: null,
                type: Number
            },
            startdesk: {
                default: null,
                type: Number
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EditTile.vue